import type { ApiResponse, ApiUrl } from '@xianlaibang/shared/types/api'

/**
 * 封装 useFetch - 用于需要 SSR 的场景
 */
export function useRequest<T, U = null>(url: ApiUrl, options?: Record<string, unknown>) {
  const nuxtApp = useNuxtApp()
  
  return useFetch<ApiResponse<T, U>>(url, {
    ...options,
    $fetch: nuxtApp.$api as typeof $fetch,
    // 自动提取 data 字段
    // transform: (res: unknown) => (res as ApiResponse<T, U>).data,
  })
}

/**
 * 封装 useAsyncData + $fetch - 更灵活的控制
 */
export function useAsyncRequest<T, U = null>(
  key: string,
  url: string,
  options?: {
    method?: 'GET' | 'POST' | 'PUT' | 'DELETE'
    body?: Record<string, any>
    query?: Record<string, any>
    immediate?: boolean
  }
) {
  const nuxtApp = useNuxtApp()
  const { method = 'GET', body, query, immediate = true } = options || {}
  
  return useAsyncData<T, U>(
    key,
    () => nuxtApp.$api<ApiResponse<T, U>>(url, {
      method,
      body,
      query,
    }).then(res => res.data),
    {
      immediate,
    }
  )
}

/**
 * 封装 $fetch - 用于事件触发的请求（不需要 SSR）
 */
export function useHttp() {
  const nuxtApp = useNuxtApp()
  const api = nuxtApp.$api as typeof $fetch
  
  return {
    get: <T, U = unknown>(url: string, query?: Record<string, any>) =>
      api<ApiResponse<T, U>>(url, { method: 'GET', query }),

    post: <T, U = unknown>(url: string, body?: Record<string, any>) =>
      api<ApiResponse<T, U>>(url, { method: 'POST', body }),

    put: <T, U = unknown>(url: string, body?: Record<string, any>) =>
      api<ApiResponse<T, U>>(url, { method: 'PUT', body }),

    delete: <T, U = unknown>(url: string, body?: Record<string, any>) =>
      api<ApiResponse<T, U>>(url, { method: 'DELETE', body }),
  }
}
